var Class       = require("Class"),
    Events      = require("Events"),
    Utils       = require("Utils"),
    // $           = require("jquery"),
    ol          = require("openlayers"),

    lineStyleFunction = require('./line-style'),
    pointStyleFunction = require('./point-style'),
    polygonStyleFunction = require('./polygon-style'),
    textStyleFunction = require('./text-style');

var PublicMapDraw = Class.extend({
    includes: [ Events ],

    statics: {
        MODE: {
            POINT: 'point',
            LINE: 'line',
            FREEHAND_LINE: 'freehandline',
            POLYGON: 'polygon',
            FREEHAND_POLYGON: 'freehandpolygon',
            TEXT: 'text'
        }, 

        LINE_STYLES: [
            [], // прямая линия
            [2, 1.1],
            [3, 2.2],
            [4, 5.5],
            [5, 8.6]
        ] 
    },

    initialize: function(map) {
        var that = this;

        that.map = map;

        that.features = {};

        that._custom_style = {};

        that.pointerMoveHandler = that.pointerMoveHandler.bind(that);
        that._onDrawStart = that._onDrawStart.bind(that);
        that._onDrawEnd = that._onDrawEnd.bind(that);

        /**
         * Названия стиля должно начинаться с типа геометрии, который он описывает
         * @type {Object}
         */
        that._original_style = {
            point_width: 6,
            point_color: [0, 134, 179, 1],
            point_border_color: [255, 255, 255, 1],
            point_border_width: 3,

            line_width: 4,
            line_color: [0, 134, 179, 1],
            line_border_width: 4,
            line_border_color: [255, 255, 255, 1],
            line_border_style: PublicMapDraw.LINE_STYLES[0],

            polygon_fill: [0, 134, 179, 1],
            polygon_border_width: 4,
            polygon_border_color: [255, 255, 255, 1],

            text_content: '',
            text_fontsize: 12,
            text_fontcolor: [0, 0, 0, 1]
        };

        that.MESSAGE = {
            START: {},
            CONTINUE: {}
        };

        that.MESSAGE.START[PublicMapDraw.MODE.POINT] = 'Клик для завершения рисования';
        that.MESSAGE.START[PublicMapDraw.MODE.LINE] = 'Клик для начала рисования';
        that.MESSAGE.START[PublicMapDraw.MODE.FREEHAND_LINE] = 'Клик и удерживайте для рисования';
        that.MESSAGE.START[PublicMapDraw.MODE.POLYGON] = 'Клик для начала рисования';
        that.MESSAGE.START[PublicMapDraw.MODE.FREEHAND_POLYGON] = 'Клик и удерживайте для рисования';
        that.MESSAGE.START[PublicMapDraw.MODE.TEXT] = 'Клик для завершения рисования';

        that.MESSAGE.CONTINUE[PublicMapDraw.MODE.POINT] = '';
        that.MESSAGE.CONTINUE[PublicMapDraw.MODE.LINE] = 'Клик для продолжения. Двойной клик для завершения';
        that.MESSAGE.CONTINUE[PublicMapDraw.MODE.FREEHAND_LINE] = 'Отпустите мышь для завершения рисования';
        that.MESSAGE.CONTINUE[PublicMapDraw.MODE.POLYGON] = 'Клик для продолжения. Двойной клик для завершения';
        that.MESSAGE.CONTINUE[PublicMapDraw.MODE.FREEHAND_POLYGON] = 'Отпустите мышь для завершения рисования';
        that.MESSAGE.CONTINUE[PublicMapDraw.MODE.TEXT] = 'Клик для завершения рисования';

        that.now_drawing = false;
        // Показывает была ли поставлена первая точка в рисовании.
        // Используется для определения какое сообщение поставить в тултип
        that.first_point_was_set = false;
        
        // для рисования фич с правильным наложением друг на друга
        that.style_zindex = 0;

        that.interaction = null;

        that.source = new ol.source.Vector();

        that.vector = new ol.layer.Vector({
            source: that.source
        });

        // Тултип с подсказкой по рисованию
        that.tooltip = null;

    },

    /**
     * Функция-помощник для метода .clone()
     * Меняет стили для фич с учетом scale
     * @param {number} scale - devicePixelRatio
     * @param  {ol.Feature} feature
     */
    _clonedFeatureNewStyle: function(scale, feature) {
        var that = this;

        var styles = feature.get('style_settings');
        var shape_type = feature.get('shape_type');

        var new_styles = that.generateStyle(shape_type, scale, styles);
        
        feature.setStyle(new_styles);
    },

    /**
     * Клонирует слой с учетом нового scale
     * @param  {number} scale - devicePixelRatio
     * @return {ol.Layer.Vector} - Новый слой 
     */
    clone: function(scale) {
        var that = this;
        var cloned_layer = Utils.cloneVectorLayer(
            that.vector,
            { /*useSpatialIndex: false*/ },
            that._clonedFeatureNewStyle.bind(that, scale)
        );

        return cloned_layer;

        // var new_style = that.getModifyStyle(scale);
        // vertex_layer.setStyle(new_style);
        
    },

    show: function() {
        var that = this;
        var map_has_layer = !!that.map.getLayers().getArray().filter(function(l) { 
            return l == that.vector; 
        })[0];
        if (!map_has_layer) {
            that.map.addLayer(that.vector);
        }
    },

    hide: function() {
        var that = this;
        that.map.removeLayer(that.vector);
    },

    isVisible: function() {
        var that = this;
        var layers = that.map.getLayers();
        var draw_layer = layers.filter(function(l) { return l === that.vector; });
        return !!draw_layer.length;
    },

    clear: function() {
        var that = this;
        that.source.clear();
    },

    updateStyle: function(style_setting, shape_type) {
        var that = this;
        if (style_setting && style_setting['text_content'] === null) {
            style_setting['text_content'] = '';
        }
        that._custom_style = _.clone(style_setting);
        that.stopDrawing();
        that.startDrawing(that.now_drawing_shape);
    },

    resetStyle: function() {

    },

    /**
     * Генерирует стили для переданного типа геометрии shape с учетом DPI sclae
     * @param  {PublicMapDraw.MODE} shape_opt - тип геометрии
     * @param  {number} scale_opt - devicePixelRatio
     * @param  {Object} styles_opt - стимлм
     * 
     * @return {ol.style.Style[]} - массив стилей
     */
    generateStyle: function(shape_opt, scale_opt, styles_opt) {
        var that = this;

        shape_opt = _.isString(shape_opt) ? shape_opt : that.now_drawing_shape;
        scale_opt = _.isNumber(scale_opt) ? scale_opt : 1;
        styles_opt = _.isObject(styles_opt) ? styles_opt : that.getAllStyles();

        switch (shape_opt) {
            case PublicMapDraw.MODE.POINT:
                return pointStyleFunction(
                    styles_opt, 
                    that.style_zindex++, 
                    scale_opt
                );
            case PublicMapDraw.MODE.LINE:
            case PublicMapDraw.MODE.FREEHAND_LINE:
                return lineStyleFunction(
                    styles_opt, 
                    that.style_zindex++, 
                    scale_opt
                );
            case PublicMapDraw.MODE.POLYGON:
            case PublicMapDraw.MODE.FREEHAND_POLYGON:
                return polygonStyleFunction(
                    styles_opt, 
                    that.style_zindex++, 
                    scale_opt
                );
            case PublicMapDraw.MODE.TEXT:
                return textStyleFunction(
                    styles_opt, 
                    that.style_zindex++, 
                    scale_opt
                );
            default:
                console.warn('Ошибка при генерации стилей', that.now_drawing_shape);
                return pointStyleFunction(
                    styles_opt, 
                    that.style_zindex++,
                    scale_opt
                );
        }
    },

    getAllStyles: function() {
        var that = this;
        var default_settings = that._original_style;
        var custom_settings = that._custom_style;
        return _.extend(default_settings, custom_settings);
    },

    getDefaultStyles: function() {
        return this._original_style;
    },

    // generateStyle: function() {
    //     var that = this;
    //     console.log(that._custom_style.icon_color, that._original_style.icon_color);
    //     var circle = new ol.style.Circle({
    //         radius: that.getStyleSetting('width'),
    //         fill  : new ol.style.Fill({
    //             color: that.getStyleSetting('color')
    //         }),
    //         stroke: new ol.style.Stroke({
    //           color: that.getStyleSetting('border_color'),
    //           width: that.getStyleSetting('border_size')
    //         })
    //     });

    //     return [
    //         /* стиль для дополнительной обводки */
    //         new ol.style.Style({
    //             stroke: new ol.style.Stroke({
    //                 color: that.getStyleSetting('border_color'), // цвет обводки
    //                 width: that.getStyleSetting('border_size'), // 
    //                 lineDash: that.getStyleSetting('border_style')
    //             }),
    //         }),
    //         /* обычный стиль */
    //         new ol.style.Style({
    //             fill  : new ol.style.Fill({
    //                 color: that.getStyleSetting('fill_color')
    //             }),
    //             stroke: new ol.style.Stroke({
    //                 color: that.getStyleSetting('fill_color'), // цвет линии
    //                 width: that.getStyleSetting('size'), // толщина линии
    //                 lineDash: that.getStyleSetting('border_style')
    //             }),
    //             image : circle
    //         })
    //     ];
    // },

    getStyleSetting: function(setting) {
        var that = this;
        var value = that._custom_style[setting] || that._original_style[setting];
        if (setting === 'border_style') {
            return PublicMapDraw.LINE_STYLES[parseInt(value)];
        } else {
            return value;
        }
    },

    getStyleForShapeType: function(shape_type) {
        var that = this;
        var filtered_styles = {};
        var current_styles = that.getAllStyles();

        shape_type = shape_type.replace('freehand', '');

        for (var style in current_styles) {
            if (
                current_styles.hasOwnProperty(style)
                && style.indexOf(shape_type) === 0
            ) {
                filtered_styles[style] = _.clone(current_styles[style]);
            }
        }

        return filtered_styles;
    },

    startDrawing: function(shape_type) {
        var that = this;

        switch (shape_type) {
            case PublicMapDraw.MODE.POINT:
            case PublicMapDraw.MODE.LINE:
            case PublicMapDraw.MODE.FREEHAND_LINE:
            case PublicMapDraw.MODE.POLYGON:
            case PublicMapDraw.MODE.FREEHAND_POLYGON:
                that.show();
                that.now_drawing = true;
                that.now_drawing_shape = shape_type;
                that.interaction = that.addDrawInteraction(shape_type);
                break;
            case PublicMapDraw.MODE.TEXT:
                that.show();
                that.now_drawing = true;
                that.now_drawing_shape = shape_type;
                that.interaction = that.addEditTextInteraction();
                break;
            default:
                console.warn('Неизвестный тип геометрии', shape_type);
        }

        that.fire('drawingstatechange', {
            is_drawing: true,
            shape_type: shape_type
        });
    },

    stopDrawing: function(clear) {
        var that = this;
        that.now_drawing = false;
        that.first_point_was_set = false;
        that.map.removeInteraction(that.interaction);
        
        that.map.un('pointermove', that.pointerMoveHandler);

        that.map.removeOverlay(that.tooltip);
        that.tooltip = null;
        if (clear) {
            that.clear();
            that.hide();
        }
        that.interaction = null;

        that.fire('drawingstatechange', {
            is_drawing: false,
            shape_type: null
        });
        
    },

    isDrawing: function() {
        return this.now_drawing;
    },

    addDrawInteraction: function(type) {
        var that = this;
        var interaction = that._createDrawInteraction(type);

        interaction.on('drawstart', that._onDrawStart);
        interaction.on('drawend', that._onDrawEnd);

        that.map.addInteraction(interaction);

        that.tooltip = that.createHelperTooltip();
        that.map.addOverlay(that.tooltip);

        return interaction;
    },

    addEditTextInteraction: function() {
        return this.addDrawInteraction(PublicMapDraw.MODE.POINT);
    },

    _getOLTypeForShapeType: function(shape_type) {
        switch (shape_type) {
            case PublicMapDraw.MODE.POINT:
                return ol.geom.GeometryType.POINT;
            case PublicMapDraw.MODE.LINE:
            case PublicMapDraw.MODE.FREEHAND_LINE:
                return ol.geom.GeometryType.LINE_STRING;
            case PublicMapDraw.MODE.POLYGON:
            case PublicMapDraw.MODE.FREEHAND_POLYGON:
                return ol.geom.GeometryType.POLYGON;
            default:
                return null;
        }
    },

    // _getShapeTypeForOLType: function(ol_geom_type) {
    //     switch (ol_geom_type) {
    //         case ol.geom.GeometryType.POINT:
    //             return PublicMapDraw.MODE.POINT.POINT;
    //         case ol.geom.GeometryType.LINE_STRING:
    //             return 
    //     }
    // },

    _createDrawInteraction: function(type, style){
        var that = this;
        var drawInteraction;
        var is_freehand = type.indexOf('freehand') === 0;
        var geom_type = that._getOLTypeForShapeType(type);

        var styles = that.generateStyle(
            that.now_drawing_shape, 
            window.devicePixelRatio
        );

        drawInteraction = new ol.interaction.Draw({
            source: that.source,
            style: styles,
            type: geom_type,
            freehand: is_freehand,
            geometryFunction: function(coords, geom){
                if (!geom) {
                    geom = new ol.geom[geom_type](coords);
                }
                geom.setCoordinates(coords);
                return geom;
            }
        });

        that.map.on('pointermove', that.pointerMoveHandler);

        return drawInteraction;
    },

    _onDrawStart: function(evt){
        var that = this;
        
        that.first_point_was_set = true;
        
        /* На время рисовки отключаем зум по двойному */
        that._dblClickZoomActive(false);
        // that.sketch = evt.feature;
        // that.sketch.setId(++that.featureIdCounter);


        that.fire('drawstart', evt);
        // инкрементируем параметр для будущих tooltip
        // that.zTooltipIndex += 1;
    },

    _onDrawEnd: function(evt){
        var that = this;

        that.first_point_was_set = false;
        
        /* Включаем зум по двойному клику после того 
            как мы закончили рисовать */

        setTimeout(function(){
            that._dblClickZoomActive(true);
        }, 10);

        // that.sketch = null;

        var feature = evt.feature;
        
        // Запоминаем настройки, с которыми рисовалась эта фича
        feature.set(
            'style_settings', 
            that.getStyleForShapeType(that.now_drawing_shape), 
            true
        );

        // Запоминаем тип этой фигуры
        feature.set('shape_type', that.now_drawing_shape, true);

        var feature_geom = feature.getGeometry();
        feature.setStyle(that.generateStyle());

        // if (feature_geom.getType() == ol.geom.GeometryType.POLYGON) {
            /* """""фикс"""""
                при редактировании нарисованной геометрии куда-то 
                пропадает возможность редактирования последнего сегмента
                геометрии. Тут мы просто добавляем первую координату в 
                конец геометрии чтобы "замкнуть" полигон.
             */
            // var polygon_coords = feature_geom.getCoordinates()[0];
            // var first_coord = polygon_coords[0];
            // polygon_coords.push(first_coord);
            // feature.setGeometry(new ol.geom.Polygon([polygon_coords]));
        // }
        

        that.fire('drawend', evt);
    },

    _dblClickZoomActive: function(active){
        var that = this;
        var interactions = that.map.getInteractions();
        for (var i = 0; i < interactions.getLength(); i++) {
            var interaction = interactions.item(i);                          
            if (interaction instanceof ol.interaction.DoubleClickZoom) {
                interaction.setActive(active);
            }
        }
    },

    pointerMoveHandler: function(evt) {
        var that = this;
        var coordinates = evt.coordinate;
        var pixel_coords = evt.pixel;

        var shape = that.now_drawing_shape;
        var helper_message = that.first_point_was_set 
                                ? that._getContinueMessage(shape)
                                : that._getStartMessage(shape);

        that.tooltip.getElement().innerHTML = helper_message;
        that.tooltip.setPosition(coordinates);
    },

    createHelperTooltip: function(){
        var that = this;
        //that._mTooltipEl
        //that._mTooltip
        var tooltip_el = document.createElement('div');

        // omjs-tooltip tooltip-static
        tooltip_el.className = 'omjs-tooltip tooltip-static measurement-tooltip';
        // задаем правильный порядок отображения
        tooltip_el.style.zIndex = that.zTooltipIndex;

        var tooltip = new ol.Overlay({
            element    : tooltip_el,
            offset     : [0, -15],
            positioning: 'bottom-center',
        });
        // that._map.addOverlay(tooltip);
        return tooltip;
    },

    _getContinueMessage: function(shape_type){
        var that = this;
        return that.MESSAGE.CONTINUE[shape_type];
    },

    _getStartMessage: function(shape_type){
        var that = this;
        return that.MESSAGE.START[shape_type];
    },


});

module.exports = PublicMapDraw;



//////////////////
// WEBPACK FOOTER
// ./src/View/PublicMapDraw/index.js
// module id = 230
// module chunks = 0